import React from "react";
import moment from "moment";
import Chart from "react-apexcharts";

const DailyRoad = ({ roads, rides }) => (
    <div>
        <Chart
            options={{
                title: {
                    text: "Road / Booking",
                    align: "left"
                },
                chart: {
                    id: "daily-range-roads-bar",
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true,
                        type: "x",
                        autoScaleYaxis: false,
                        zoomedArea: {
                            fill: {
                                color: "#90CAF9",
                                opacity: 0.4
                            },
                            stroke: {
                                color: "#0D47A1",
                                opacity: 0.4,
                                width: 1
                            }
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: "50%",
                        endingShape: "arrow"
                    }
                },
                stroke: {
                    curve: "smooth"
                },
                xaxis: {
                    categories: Object
                        .keys(roads)
                        .map(timestamp => moment(parseInt(timestamp, 10))
                            .format("YYYY-MM-DD")),
                    type: "datetime",
                    labels: {
                        format: "dd MMM (ddd)"
                    }
                },
                markers: {
                    size: 6,
                    strokeWidth: 3,
                    fillOpacity: 0,
                    strokeOpacity: 0,
                    hover: {
                        size: 8
                    }
                },
            }}
            series={[{
                name: "Road users",
                data: Object.keys(roads)
                    .map(day => roads[day].usersWhoRoad)
            }, {
                name: "Booking count",
                data: Object.keys(roads)
                    .map(day => roads[day].bookingsCount)
            }]}
            type="line"
            width="100%"
            height={300}
        />
        <Chart
            options={{
                title: {
                    text: "Rides",
                    align: "left"
                },
                chart: {
                    id: "daily-range-rides-bar",
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true,
                        type: "x",
                        autoScaleYaxis: false,
                        zoomedArea: {
                            fill: {
                                color: "#90CAF9",
                                opacity: 0.4
                            },
                            stroke: {
                                color: "#0D47A1",
                                opacity: 0.4,
                                width: 1
                            }
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "55%",
                        endingShape: "rounded"
                    },
                },
                stroke: {
                    curve: "smooth"
                },
                xaxis: {
                    categories: Object
                        .keys(rides)
                        .map(timestamp => moment(parseInt(timestamp, 10))
                            .format("YYYY-MM-DD")),
                    type: "datetime",
                    labels: {
                        format: "dd MMM (ddd)"
                    }
                },
                markers: {
                    size: 6,
                    strokeWidth: 3,
                    fillOpacity: 0,
                    strokeOpacity: 0,
                    hover: {
                        size: 8
                    }
                },
                dataLabels: {
                    enabled: false
                },
            }}
            series={[{
                name: "Road Users",
                data: Object.keys(rides)
                    .map(day => rides[day].usersWhoRoad)
            }, {
                name: "Ride Amount",
                data: Object.keys(rides)
                    .map(day => rides[day].rideAmount)
            }, {
                name: "Ride Count ",
                data: Object.keys(rides)
                    .map(day => rides[day].rideCount)
            }]}
            type="bar"
            width="100%"
            height={300}
        />
    </div>
);

export default DailyRoad;



// WEBPACK FOOTER //
// ./src/views/pages/reports/daily-road.js